<template>
  <el-upload
      class="upload-demo"
      ref="upload"
      action="#"
      :on-remove="handleRemove"
      :on-change="handleChange"
      :before-upload="beforeUpload"
      :on-preview="handlePreview"
      :file-list="fileList"
      :auto-upload="false"
      list-type="picture">
    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
  </el-upload>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxSize: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      fileList: []
    }
  },
  methods: {
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
      });
    },

    async getFiles() {
      let files = [];
      for (const file of this.fileList) {
        const base64Data = await this.fileToBase64(file.raw);
        files.push({
          name: file.name,
          type: file.type,
          size: file.size,
          data: base64Data
        });
      }
      return files;
    },

    beforeUpload(file) {
      const isLt = file.size / 1024 / 1024 < this.maxSize;
      if (!isLt) {
        this.$message.error(`上传文件大小不能超过 ${this.maxSize}MB!`);
      }
      return isLt;
    },

    handlePreview(file) {
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit('input', fileList);
    },

    handleChange(file, fileList) {
      this.fileList = fileList;
      this.$emit('input', fileList);
    },

    clearFiles() {
      this.$refs.upload.clearFiles();
      this.fileList = [];
    },

    async loadFiles(files) {
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      for (const key in files) {
        const file = files[key];
        let name = file.split('/').pop();
        try {
          const response = await this.$axios({
            method: 'get',
            url: `/download/${encodeURIComponent(file)}`,
            responseType: 'arraybuffer',
          });
          const blob = new Blob([response.data], {type: 'application/octet-stream'});
          const url = window.URL.createObjectURL(blob);
          this.fileList.push({
            name,
            url,
            raw: blob
          });
        } catch (e) {
          console.error('加载文件失败', e);
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
